/**
 * @generated SignedSource<<80dc6740284b8742838616dc2cdeeb2c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateCategoryInput = {
  aliasOf?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  description?: string | null | undefined;
  id: string;
  name?: string | null | undefined;
  parentDatabaseId?: number | null | undefined;
  parentId?: string | null | undefined;
  pinnedContent?: ReadonlyArray<string | null | undefined> | null | undefined;
  slug?: string | null | undefined;
  uxOrder?: number | null | undefined;
};
export type Category_UpdatePinnedContent_Mutation$variables = {
  input: UpdateCategoryInput;
};
export type Category_UpdatePinnedContent_Mutation$data = {
  readonly updateCategory: {
    readonly category: {
      readonly id: string;
      readonly znglycategory: {
        readonly pinnedContent: ReadonlyArray<{
          readonly id?: string;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Category_UpdatePinnedContent_Mutation$rawResponse = {
  readonly updateCategory: {
    readonly category: {
      readonly id: string;
      readonly znglycategory: {
        readonly pinnedContent: ReadonlyArray<{
          readonly __typename: "ZnglyVideo";
          readonly __isNode: "ZnglyVideo";
          readonly id: string;
        } | {
          readonly __typename: string;
          readonly __isNode: string;
          readonly id: string;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Category_UpdatePinnedContent_Mutation = {
  rawResponse: Category_UpdatePinnedContent_Mutation$rawResponse;
  response: Category_UpdatePinnedContent_Mutation$data;
  variables: Category_UpdatePinnedContent_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "ZnglyVideo",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Category_UpdatePinnedContent_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCategoryPayload",
        "kind": "LinkedField",
        "name": "updateCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Category_Znglycategory",
                "kind": "LinkedField",
                "name": "znglycategory",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "pinnedContent",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Category_UpdatePinnedContent_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCategoryPayload",
        "kind": "LinkedField",
        "name": "updateCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Category_Znglycategory",
                "kind": "LinkedField",
                "name": "znglycategory",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "pinnedContent",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v3/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "203e6f963475c5254d815bef9b509619",
    "id": null,
    "metadata": {},
    "name": "Category_UpdatePinnedContent_Mutation",
    "operationKind": "mutation",
    "text": "mutation Category_UpdatePinnedContent_Mutation(\n  $input: UpdateCategoryInput!\n) {\n  updateCategory(input: $input) {\n    category {\n      id\n      znglycategory {\n        pinnedContent {\n          __typename\n          ... on ZnglyVideo {\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f7ac688c60d6c6fe70ff412dee7e02e7";

export default node;
